module.exports = __webpack_public_path__ + "img/bracing-documents.069608d2.png";